import { useEffect } from 'react';

import { Box, Button } from '@mui/material';
import { useForm } from 'react-hook-form';

import { SelectFormField, TextFormField } from 'components/FormFields';
import strings from 'constants/index';
import { formStyles } from 'styles/formStyles';
import { normalizeEnumValues } from 'utils/normalizers.utils';

interface TablePresetCreateFormValues {
  name: string;
  columns: Array<string>;
}

const TablePresetsForm = ({ columns, onSubmit }) => {
  const {
    control,
    reset,
    handleSubmit,
    formState: { isSubmitSuccessful },
  } = useForm<TablePresetCreateFormValues>();

  useEffect(() => {
    if (isSubmitSuccessful) {
      reset();
    }
  }, [isSubmitSuccessful, reset]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Box sx={formStyles.section}>
        <TextFormField control={control} required name="name" label={strings.name} />
        <SelectFormField
          control={control}
          name="columns"
          label={strings.columns}
          values={normalizeEnumValues(columns)}
          multiple={true}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            disablePortal: true,
          }}
          required
        />
        <Button variant="contained" autoFocus type="submit">
          {strings.save}
        </Button>
      </Box>
    </form>
  );
};

export default TablePresetsForm;
